module.exports = __webpack_public_path__ + "static/media/prism-3.87bd883a.mp3";